import React, { useEffect, useState } from "react";
import apiCall from "../network/api";
import { loader } from "../utils/svg";

const SendEmail = () => {
  const [email, setEmail] = useState(null);
  const [emailMessage, setEmailMessage] = useState("");

  useEffect(() => {
    // Get the hash part of the URL
    const hash = window.location.hash;

    // Find the query string after the '#'
    const queryString = hash.split("?")[1];

    // Parse the query string using URLSearchParams
    if (queryString) {
      const params = new URLSearchParams(queryString);
      const emailValue = params.get("email");
      setEmail(emailValue);
    }
  }, []);

  // Empty dependency array to run only once when the component mounts

  useEffect(() => {
    const fetchData = async () => {
      try {
        await apiCall({
          endpoint: "/otp/send-email",
          method: "GET",
          params: {
            email: email,
          },
        }).then((data) => {
          setEmailMessage(data?.message);
        });
      } catch (err) {
        setEmailMessage(err?.data?.message);
      } finally {
      }
    };
    if (email) fetchData();
  }, [email]);
  return (
    <div className="m-3 text-gray-500 font-medium text-md">
      {emailMessage?.length > 0 ? <p>{emailMessage}</p> : loader()}
    </div>
  );
};

export default SendEmail;
